import React from 'react';
import Icon from '@atlaskit/icon/utility/chevron-right';
import { Box } from '@atlaskit/primitives';
export function ExpandButton() {
  return /*#__PURE__*/React.createElement(Box, {
    paddingInline: "space.075"
  }, /*#__PURE__*/React.createElement(Icon, {
    label: 'Edit'
  }));
}